<select name="award-certificate-recipient-select"
        id="award-certificate-recipient">
    <option value=''>{{selectUser}}</option>
    {{#each recipients}}
        <option value="{{type}}:{{id}}">{{name}}</option>
    {{/each}}
</select>
